<!-- =========================================================
     Start Short Course List
========================================================= -->

<div class="ecb-web-public-page">

  <!-- Start Short Courses List Banner Section -->
  <section class="ecb-web-short-courses-list-banner-section">

    <!-- Start Short Courses List Banner Overlay -->
    <div class="ecb-web-short-courses-list-banner-overlay"></div>
    <!-- End Short Courses List Banner Overlay -->

    <div class="container ecb-web-short-courses-list-banner-container">

      <div class="row align-items-center">

        <!-- Start Short Courses List Banner Content -->
        <div class="col-12 col-lg-12">
          <!-- ===================================================== -->
          <!-- CLIENT TYPE -->
          <!-- ===================================================== -->

          <div class=" ">

            <div class="ecb-x-client-type-heading">
               <div class="col-12 col-lg-5">

                  <div class="ecb-web-book-banner-content">

                    <span class="ecb-web-hsr-banner-label">

                    </span>
                    <span class="pill">ECB Training</span>

                    <h1>
                       Training Booking
                    </h1>

                     <div class="ecb-web-short-title-line"></div>

                    <p style="color:white">
                     Please select the type of booking you would like to make.
                    </p>

                  </div>



                </div>

              

            </div>


            <div class="ecb-x-client-type-buttons ecb-x-client-type-wrapper"  >


              <!-- General Public -->
              <button type="button" class="btn ecb-x-client-type-button "
                [class.active]="selectedClientType === 'GENERAL'" (click)="selectClientType('GENERAL')">

                <span class="ecb-corporate-switch-icon">
                  <i class="bi bi-person"></i>
                </span>

                <div>

                  <strong>
                    General Public Clients
                  </strong>

                  <span>
                    View available courses and book online
                  </span>

                </div>

              </button>


              <!-- Corporate -->
              <button type="button" class="btn ecb-x-client-type-button"
                [class.active]="selectedClientType === 'CORPORATE'" (click)="selectClientType('CORPORATE')">

                <span class="ecb-corporate-switch-icon">
                  <i class="bi bi-buildings"></i>
                </span>

                <div>

                  <strong>
                    Corporate Clients
                  </strong>

                  <span>
                    Create a group training enquiry
                  </span>

                </div>

              </button>

              <!-- Corporate -->
              <button type="button" class="btn ecb-x-client-type-button"
                [class.active]="selectedClientType === 'CALENDAR'" (click)="selectClientType('CALENDAR')">

                <span class="ecb-corporate-switch-icon">
                  <i class="bi bi-calendar-date"></i>
                </span>

                <div>

                  <strong>
                    Calendar
                  </strong>

                  <span>
                    Create a group training enquiry
                  </span>

                </div>

              </button>

            </div>

          </div>


        </div>

      </div>

    </div>

  </section>
  <!-- End Short Courses List Banner Section -->

</div>



<!-- Start Client Selection Section -->
<section class="ecb-x-client-selection-section">

  <div class="container-fluid ecb-x-client-selection-container">





    <!-- ===================================================== -->
    <!-- GENERAL PUBLIC -->
    <!-- ===================================================== -->

    <div *ngIf="selectedClientType ==='GENERAL'">
      <app-x-short-course-list></app-x-short-course-list>
    </div>

    <!-- ===================================================== -->
    <!-- CORPORATE CLIENT -->
    <!-- ===================================================== -->

    <div *ngIf="selectedClientType === 'CORPORATE' ">
      <app-x-course-multi-form></app-x-course-multi-form>
    </div>

    <!-- ===================================================== -->
    <!-- CALENDAR -->
    <!-- ===================================================== -->

    <div *ngIf="selectedClientType === 'CALENDAR' ">
      <app-x-course-calendar></app-x-course-calendar>
    </div>

  </div>

</section>
<!-- End Client Selection Section -->